export const defaultLang = process.env.REACT_APP_DEFAULT_LANG ?? 'ru';
